import anime from 'animejs';
import inView from 'in-view';


document.addEventListener('DOMContentLoaded', function () {


    /**
     * Animate elements when they come in to view
     */
    inView('.js-in-view')
        .on('enter', el => { el.classList.add('inView') })

    /**
     * Animate elements when they come in to view
     */

    inView.offset({
        top: 100,
        bottom: 200
    });

    /**
     * Scroll new section into view
     * @param {number} id 
     */
    const scrollToSlide = (id) => {

        let presentation = document.querySelector('.presentation');
        let element = document.querySelector(`.js-slide-item[data-id="${id}"]`);

        if (element) {
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: presentation.offsetTop + element.offsetTop
            });
        }
    };


    let slideNavs = document.querySelectorAll('.js-slide-nav');

    // When a user clicks   on a slide nav, the nav will slide open and close.
    slideNavs.forEach(slideNav => {
        slideNav.addEventListener('click', function () {
            scrollToSlide(slideNav.dataset.id);
        });
    });

    // When a user clicks down to the next slide nav item
    let slideDown = document.querySelector('.js-slide-nav-down');

    if (slideDown) {
        slideDown.addEventListener('click', function (event) {
            event.preventDefault();
            let currentSlide = document.querySelector(`.js-slide-nav.current`);
            scrollToSlide(parseInt(currentSlide.dataset.id) + 1);
        });
    }

    // When a user clicks down to the next slide nav item
    let slideUp = document.querySelector('.js-slide-nav-up');

    if (slideUp) {
        slideUp.addEventListener('click', function (event) {
            event.preventDefault();
            let currentSlide = document.querySelector(`.js-slide-nav.current`);
            scrollToSlide(parseInt(currentSlide.dataset.id) - 1);
        });
    }

    /**
     * Animate elements when they come in and out of view
     */
    inView('.js-slide-item-content')
        .on('enter', el => {
            el.classList.add('inView');

            slideNavs.forEach(slideNav => {
                slideNav.classList.remove('current');
            });

            document.querySelector(`.js-slide-nav[data-id="${el.dataset.id}"]`).classList.add('current');
        })
        .on('exit', el => {
            el.classList.remove('inView');
        });





    /**
     * Calculates the percentage of the element that has been seen.
     * @returns {number}
     */
    const percentageSeen = (element, offset = 1) => {
        // Get the relevant measurements and positions 
        const viewportHeight = window.innerHeight;
        const elementOffsetTop = element.getBoundingClientRect().top;
        const elementHeight = element.getBoundingClientRect().height;

        // Calculate percentage of the element that's been seen
        const distance = (viewportHeight) - elementOffsetTop;
        const percentage = Math.round(distance / ((viewportHeight + (elementHeight * offset)) / 100));

        // Restrict the range to between 0 and 100
        return Math.min(100, Math.max(0, percentage));

    }


    /**
     * Animates to a certain percentage of the animation timeline
     * @param {object} animation 
     */
    const seekAnimation = (animation, element) => {
        animation.seek((percentageSeen(element) / 100) * animation.duration);
    }

    /**
     * Animates to a certain percentage of the animation timeline
     * @param {object} animation 
     */
    const seekAnimationReverse = (animation, element, offset = 1) => {
        animation.seek(((1 - percentageSeen(element, offset) / 100)) * animation.duration);
    }



    /**
     * Bee animation to the right
     */
    let bees = document.querySelectorAll('.js-animate-bee-on-path');

    if (bees.length) {

        bees.forEach(bee => {

            let path = anime.path(bee.querySelector('#dashedPath'));

            let beeElement = bee.querySelector('.js-bee');

            let animation = anime({
                targets: beeElement,
                translateX: path('x'),
                translateY: path('y'),
                rotate: path('angle'),
                easing: 'linear',
                duration: 10,
                autoplay: false
            });

            window.addEventListener('scroll', () => { seekAnimation(animation, bee) });

            seekAnimation(animation, bee);

        });

    }


    /**
     * Bee path animation
     */
    let beePaths = document.querySelectorAll('.js-animate-bee-on-path');

    if (beePaths.length) {

        beePaths.forEach(beePath => {

            let animation = anime({
                targets: beePath.querySelector(`#${beePath.dataset.id}`),
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'linear',
                duration: 3000,
                autoplay: false,
                loop: true
            });

            window.addEventListener('scroll', () => { seekAnimation(animation, beePath) });

            seekAnimation(animation, beePath);

        });

    }


    /**
     * Standard path animation
     */
    let pathsRight = document.querySelectorAll('.js-animate-path-right');

    if (pathsRight.length) {

        pathsRight.forEach(pathRight => {

            let animation = anime({
                targets: pathRight.querySelector(`#${pathRight.dataset.id}`),
                strokeDashoffset: [anime.setDashoffset, 3850],
                easing: 'linear',
                direction: 'reverse',
                duration: 3000,
                autoplay: false
            });

            window.addEventListener('scroll', () => { seekAnimation(animation, pathRight) });

            seekAnimation(animation, pathRight);

        });

    }

    /**
     * Reverse path animation
     */
    let pathsLeft = document.querySelectorAll('.js-animate-path-left');

    if (pathsLeft.length) {

        pathsLeft.forEach(pathLeft => {

            let animation = anime({
                targets: pathLeft.querySelector(`#${pathLeft.dataset.id}`),
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'linear',
                direction: 'reverse',
                duration: 3000,
                autoplay: false
            });

            window.addEventListener('scroll', () => { seekAnimation(animation, pathLeft) });

            seekAnimation(animation, pathLeft);

        });

    }

    /**
    * Banner animation
    */
    let bannerPaths = document.querySelectorAll('.js-mask-animation');

    if (bannerPaths.length) {

        bannerPaths.forEach(bannerPath => {

            let animation = anime({
                targets: '.js-mask-animation path',
                d: [
                    { value: 'M1633,70 L0,70 L0,20.368841 C115.400193,59.332326 200.621969,37.5552145 428,20.368841 C602.756134,7.15989483 1031.08594,59.332326 1179.97621,59.332326 C1342.18864,59.332326 1506.99336,70 1633,7.15989483 L1633,70 Z' },
                    { value: 'M1633,70 L0,70 L0,30.1537254 C116.666667,14.9145379 256.833333,14.9145379 420.5,30.1537254 C537.484668,41.0462995 1051.61974,2.05493239 1192.4598,7.15989483 C1371.82224,13.6611595 1518.66898,33.0336372 1633,65.2773279 L1633,70 Z' },
                ],
                easing: 'linear',
                direction: 'alternate',
                duration: 10000,
                autoplay: true,
                loop: true
            });

            window.addEventListener('scroll', () => { seekAnimation(animation, bannerPath) });

            seekAnimation(animation, bannerPath);

        });

    }


    /**
     * Bee animation to the right
     */
    let beesLeft = document.querySelectorAll('.js-animate-bee-on-path-left');

    if (beesLeft.length) {

        beesLeft.forEach(bee => {

            let path = anime.path(bee.querySelector('#dashedPath'));

            let beeElement = bee.querySelector('.js-bee');

            let animation = anime({
                targets: beeElement,
                translateX: path('x'),
                translateY: path('y'),
                rotate: path('angle'),
                easing: 'linear',
                direction: 'reverse',
                duration: 10,
                autoplay: false
            });

            window.addEventListener('scroll', () => { seekAnimationReverse(animation, bee) });

            seekAnimationReverse(animation, bee);

        });

    }


    /**
     * Bee path animation
     */
    let beePathsLeft = document.querySelectorAll('.js-animate-bee-on-path-left');

    if (beePathsLeft.length) {

        beePathsLeft.forEach(beePath => {

            let animation = anime({
                targets: beePath.querySelector(`#${beePath.dataset.id}`),
                strokeDashoffset: [anime.setDashoffset, 3050],
                easing: 'linear',
                direction: 'reverse',
                duration: 3000,
                autoplay: false
            });

            window.addEventListener('scroll', () => { seekAnimation(animation, beePath) });

            seekAnimation(animation, beePath);

        });

    }

    /**
     * Scroll slider into view
     */
    let sliders = document.querySelectorAll('.js-scroll-into-view');

    if (sliders.length) {

        sliders.forEach(slider => {

            let animation = anime({
                targets: slider,
                translateX: '15%',
                easing: 'linear',
                direction: 'reverse',
                duration: 3000,
                autoplay: false
            });

            window.addEventListener('scroll', () => { seekAnimationReverse(animation, slider, 0) });

            seekAnimationReverse(animation, slider, 0);

        });

    }


    /**
     * Random wiggle animations
     */
    function randomWiggle() {

        anime({
            targets: '.js-wiggle',
            translateX: function () {
                return anime.random(7, 15);
            },
            translateY: function () {
                return anime.random(7, 15);
            },
            rotate: function () {
                return anime.random(-5, 5);
            },
            duration: function () {
                return anime.random(1000, 2000);
            },
            easing: 'easeOutInQuad',
            complete: randomWiggle
        });
    }

    /**
     * Wiggle animations
     */
    let wiggles = document.querySelectorAll('.js-wiggle');

    if (wiggles.length) randomWiggle();


    /** 
     * Responsive embedded media
     */
    let media = document.querySelectorAll('.embed');

    if (media.length) {

        media.forEach(mediaItem => {
            let iframe = mediaItem.querySelector('iframe');

            if (iframe) {
                let width = iframe.width || 16;
                let height = iframe.height || 9;

                mediaItem.classList.add('media--responsive');
                mediaItem.style.paddingBottom = (100 / width * height) + '%';
            }
        });
    }
}, false);


